const getters = {
  cwkPhone: state => state.global.cwkPhone,
  txxzcSite: state => state.global.txxzcSite,
  currentCity: state => state.global.currentCity,
  currentPos: state => state.global.currentPos,
  nearStore: state => state.global.nearStore
}
export default getters
